// CUSTOM: "Make it 2" upsell in the free-delivery bar (snippets/custom-free-delivery-bar.liquid).
// Loaded as a classic deferred script from snippets/stylesheets.liquid (NOT type="module": a module
// script before Horizon's import map makes older Safari/Chrome ignore the import map entirely).
//
// Step 1: swap the single-alarm line for the Double Pack variant with /cart/update.js.
// Step 2: let Horizon's own <cart-items-component> refresh itself via its public updateQuantity()
// (a no-op "line 1 → qty 1" change). That is the same path the +/- buttons use, so the drawer is
// morphed in hydration mode and stays open and scrollable. Re-rendering the header section ourselves
// broke the open <dialog> (it lost its modal state and left the page scroll-locked).
(function () {
  document.addEventListener('click', async function (event) {
    var button = event.target instanceof Element ? event.target.closest('[data-cfd-upgrade]') : null;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    var remove = button.dataset.remove;
    var add = button.dataset.add;
    if (!remove || !add) return;

    var cartItems = button.closest('cart-items-component') || document.querySelector('cart-items-component');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      var updates = {};
      updates[remove] = 0;
      updates[add] = 1;
      var routes = (window.Theme && window.Theme.routes) || {};
      var response = await fetch(routes.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
      var cart = await response.json();
      if (!response.ok || cart.status) throw new Error(cart.description || 'Cart update failed');

      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        cartItems.updateQuantity({ line: 1, quantity: 1, action: 'change' });
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
